export default "__VITE_PUBLIC_ASSET__1da3bab9__"